import styled, { css } from "styled-components";

import { COLORS } from "@/react/theme/constants";

const HasErrorSpan = styled.span`
  ${({ hasError }) =>
    hasError &&
    css`
      color: ${COLORS.danger};
    `};
`;

export default HasErrorSpan;
